import React, { FC } from 'react';
import { Badge, Col, Container, Figure, Row } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { IconContext } from 'react-icons';
import { FaGithub } from 'react-icons/fa';
import webCV from '../assets/projects/webCV.png';
import myRobots from '../assets/projects/website-underconstruction.png';
import { Skills } from './skills';

/**
* Personal Projects section
*/
export const PersonalProjects: FC = () => {
    const { t } = useTranslation();

    return (
        <Container id="Projects" className="pt-5">
            <Row className="mb-4 justify-content-center">
                <Col xs={true} md={8} className="pt-2 pb-2">
                    <Badge><h2 className="titles rounded">{t('navbar.personalProjects')}</h2></Badge>
                </Col>
            </Row>
            <Row className="justify-content-center pt-5 pb-5 mt-3 mb-3">
                <Col xs={12} md={true}>
                    <Figure>
                        <Figure.Image
                            height="75%"
                            width="75%"
                            alt="171x180"
                            src={myRobots}
                        />
                    </Figure>
                </Col>
                <Col xs={12} md={true} className="align-self-center pr-5">
                    <h3>
                        <Trans i18nKey="projects.0.title">
                            <strong></strong>
                        </Trans>
                    </h3>
                    <p className="text-left">{t('projects.0.body')}</p>
                    <Row>
                        <Col xs={4}>
                            <a
                                href="https://github.com/L33ROY/MyRobot"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <IconContext.Provider value={{ size: '2em' }}>
                                    <div>
                                        <FaGithub />
                                    </div>
                                </IconContext.Provider>
                            </a>
                        </Col>
                        <Col className="text-right pr-md-5">
                        </Col>
                    </Row>
                </Col>
            </Row>
            
            <Row className="justify-content-center pt-5 pb-5 mt-3 mb-3">
                <Col xs={12} md={true}>
                    <Figure>
                        <Figure.Image
                            height="75%"
                            width="75%"
                            alt="171x180"
                            src={webCV}
                        />
                    </Figure>
                </Col>
                <Col xs={12} md={true} className="align-self-center pr-5">
                    <h3>
                        <Trans i18nKey="projects.1.title">
                            <strong></strong>
                        </Trans>
                    </h3>
                    <p className="text-left">{t('projects.1.body')}</p>
                    <Row>
                        <Col xs={4}>
                            <a
                                href="https://github.com/L33ROY/WebCV"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <IconContext.Provider value={{ size: '2em' }}>
                                    <div>
                                        <FaGithub />
                                    </div>
                                </IconContext.Provider>
                            </a>
                        </Col>
                        <Col className="text-right pr-md-5">
                            <Skills skillName="React" />
                            <Skills skillName="Bootstrap" />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

/**
* Professional Projects section
*/
export const ProfessionalProjects: FC = () => {
    const { t } = useTranslation();

    return (
        <Container id="Projects" className="pt-5">
            <Row className="mb-4 justify-content-center">
                <Col xs={true} md={8} className="pt-2 pb-2">
                    <Badge><h2 className="titles rounded">{t('navbar.professionalProjects')}</h2></Badge>
                </Col>
            </Row>
            <Row className="justify-content-center pt-5 pb-5 mt-3 mb-3">
                <Col xs={12} md={true}>
                    <Figure>
                        <Figure.Image
                            height="75%"
                            width="75%"
                            alt="171x180"
                            src={myRobots}
                        />
                    </Figure>
                </Col>
                <Col xs={12} md={true} className="align-self-center pr-5">
                    <h3>
                        <Trans i18nKey="projects.0.title">
                            <strong></strong>
                        </Trans>
                    </h3>
                    <p className="text-left">{t('projects.0.body')}</p>
                    <Row>
                        <Col xs={4}>
                            <a
                                href="https://github.com/L33ROY/MyRobot"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <IconContext.Provider value={{ size: '2em' }}>
                                    <div>
                                        <FaGithub />
                                    </div>
                                </IconContext.Provider>
                            </a>
                        </Col>
                        <Col className="text-right pr-md-5">
                        </Col>
                    </Row>
                </Col>
            </Row>
            
            <Row className="justify-content-center pt-5 pb-5 mt-3 mb-3">
                <Col xs={12} md={true}>
                    <Figure>
                        <Figure.Image
                            height="75%"
                            width="75%"
                            alt="171x180"
                            src={webCV}
                        />
                    </Figure>
                </Col>
                <Col xs={12} md={true} className="align-self-center pr-5">
                    <h3>
                        <Trans i18nKey="projects.1.title">
                            <strong></strong>
                        </Trans>
                    </h3>
                    <p className="text-left">{t('projects.1.body')}</p>
                    <Row>
                        <Col xs={4}>
                            <a
                                href="https://github.com/L33ROY/WebCV"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <IconContext.Provider value={{ size: '2em' }}>
                                    <div>
                                        <FaGithub />
                                    </div>
                                </IconContext.Provider>
                            </a>
                        </Col>
                        <Col className="text-right pr-md-5">
                            <Skills skillName="React" />
                            <Skills skillName="Bootstrap" />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}
